module.exports = "<div id=\"pager-popover\">\r\n    <form class=\"form-horizontal\" id=\"pager-popover-form\">\r\n        <div class=\"form-group\">\r\n            <label for=\"pagerPageNum\" class=\"control-label\">Go to page: </label>\r\n            <input id=\"pagerPageNum\" type=\"number\" value=\"{{CurrentPage}}\" class=\"span1 form-control\" min=\"1\" max=\"{{PageCount}}\" />\r\n        </div>\r\n        <input type=\"submit\" class=\"btn btn-primary\" value=\"GO\" />\r\n    </form>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/search/views/pager-popover.html
// module id = 420
// module chunks = 1